import * as React from "react";
import { Card } from "semantic-ui-react";
import { CaseType } from "@teamprevent/common/model";

import { APPOINTMENT_DATA_FORMAT } from "@teamprevent/common/calendar";

import { BookAppointmentTaskListModel } from "../models";

import { ChooseAndBookButton } from "./ChooseAndBookButton";
import { NotesButton } from "./NotesButton";

import { Link } from "redux-little-router";

interface Props {
    task: BookAppointmentTaskListModel;
    onChooseAndBook: (task: BookAppointmentTaskListModel) => void;
}

export class BookAppointmentCard extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.onDragStart = this.onDragStart.bind(this);
    }

    public render() {
        const bookTask = this.props.task;
        return (
            <Card draggable key={bookTask.id} className="card"  onDragStart={this.onDragStart}>
                <Card.Content>
                    <Card.Header content={bookTask.taskType} />
                    <Card.Meta content={bookTask.dueDate && bookTask.dueDate.format("DD/MM/YYYY")} />
                    <Card.Description>
                        Employee name: <Link
                            href={`/customers/${bookTask.customer.id}/employeeRecords/${bookTask.employee.id}`}
                            target="_blank"
                        >
                            {bookTask.employee.name}
                        </Link>
                    </Card.Description>
                    <Card.Description content={`Employee Postcode: ${bookTask.employeePostcode}`} />
                    <Card.Description>
                        Customer name: <Link href={`/customers/${bookTask.customer.id}`} target="_blank"> {bookTask.customer.name} </Link>
                    </Card.Description>
                    {(bookTask.immunisationTypeTasks || []).map((immunisationType, index) =>
                        <Card.Description key={index}>{immunisationType.name}</Card.Description>
                    )}
                    <Card.Content extra>
                        {bookTask.caseType !== CaseType.HEALTH_SURVEILLANCE
                            ? (<ChooseAndBookButton
                                task={bookTask}
                                onClick={this.props.onChooseAndBook}
                            />) : ("")
                        }
                        <NotesButton task={bookTask} />
                    </Card.Content>
                </Card.Content>
            </Card>
        );
    }

    private onDragStart = (event: React.DragEvent<HTMLElement>) => {
        event.dataTransfer.setData(APPOINTMENT_DATA_FORMAT, this.props.task.id);
    };
}
